import React from "react";
import "./curebaySolutions.css";

// Same promotion pills as the home page cards
import HaemoglobinIcon from "../../Assets/Images/smartvitals.svg";
import LanguageIcon    from "../../Assets/Images/rewamp/caresathi and symptom checker pill icon.svg";
import TbScreeningIcon from "../../Assets/Images/lungscare/lungscare.svg";

// Sparkle icon (lucide "sparkles") for the "New" badge — teal, matches the Figma pill
const NEW_BADGE_ICON = `data:image/svg+xml;utf8,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#0E9F7E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/><path d="M20 3v4"/><path d="M22 5h-4"/><path d="M4 17v2"/><path d="M5 18H3"/></svg>')}`;

const PROMOTIONS = {
  smartvitals:    { icon: HaemoglobinIcon, label: "Now with Haemoglobin Check" },
  caresathi:      { icon: LanguageIcon,    label: "Now in 8 languages" },
  symptomchecker: { icon: LanguageIcon,    label: "Now in 8 languages" },
  lungscare:      { icon: TbScreeningIcon, label: "TB Screening Support available now" },
  visioncare:     { icon: NEW_BADGE_ICON,  label: "New", variant: "new" },
};

// "Check our other AI Solutions" → "Check our" in primary, rest in green
const splitHeading = (heading = "") => {
  const m = heading.match(/^(check\s+our)\s+(.*)$/i);
  if (m) return [m[1], m[2]];
  const words = heading.trim().split(" ");
  const last = words.length > 1 ? words.pop() : "";
  return [words.join(" "), last];
};

const CurebaySolutions = ({ data = {}, onCardClick }) => {
  const sixthsub = data?.sixthsub || [];
  // Used only on solution landing pages, where this section lists the *other* solutions —
  // the heading is fixed here rather than taken from the CMS
  const [headingMain, headingAccent] = splitHeading("Other AI Solutions");

  return (
    <section className="cs-other">

      {/* Section Header — left aligned */}
      <h2 className="cs-other-heading">
        {headingMain}{headingAccent && " "}
        {headingAccent && <span className="cs-other-heading-accent">{headingAccent}</span>}
      </h2>
      {data.description && <p className="cs-other-desc">{data.description}</p>}

      {/* Cards Grid */}
      <div className="cs-other-grid">
        {sixthsub.map((item) => {
          const promotion = PROMOTIONS[item.subheading?.toLowerCase()] || null;

          return (
            <div
              key={item.id}
              onClick={() => onCardClick?.(item)}
              className="cs-other-card"
              style={{ cursor: "pointer" }}
            >
              {/* Text top */}
              <div className="cs-other-card-text">
                {promotion && (
                  <span className={`cs-other-pill${promotion.variant === "new" ? " cs-other-pill--new" : ""}`}>
                    <img src={promotion.icon} alt="" aria-hidden="true" />
                    {promotion.label}
                  </span>
                )}

                <h3 className="cs-other-card-title">
                  {item.subheading}
                </h3>

                <p className="cs-other-card-desc">{item.description}</p>
              </div>

              {/* Image */}
              <div className="cs-other-card-img">
                {item.imgurl ? (
                  <img src={item.imgurl} alt={item.subheading} />
                ) : (
                  <div className="cs-other-card-img-fallback">
                    {item.subheading?.[0] || "?"}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default CurebaySolutions;
